import React, { useState, useEffect, useContext } from "react";
import useStyles from "../styles/dashboard";
import {FirebaseContext} from "../../../context/firebase";
import { useLocation } from "react-router-dom";

interface Props {}

const AppBar: React.FC<Props> = () => {
  const { data, error, refresh } = useContext(FirebaseContext);
  const classes = useStyles();
  const [user, setUser] = useState(data);
  const [showAlert, setShowAlert] = useState(false);
  const [accountLockDownLevel, setAccountLockDownLevel] = useState(user.accountLockDownStatus)
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const restrictedPaths = [
      "/dashboard/pay-bills",
      "/dashboard/transfer-funds",
      "/dashboard/investments"
    ];
    const isPayBillsSubRoute = /^\/pay-bills\/.+/.test(path);
    // Show alert if user can't transact and is on any restricted route
    if (!user.canTransact && (restrictedPaths.includes(path) || isPayBillsSubRoute)) {
      setShowAlert(true);
      const timer = setTimeout(() => setShowAlert(false), 20000); // hide after 20s
      return () => clearTimeout(timer);
    } else {
      setShowAlert(false);
    }
  }, [location.pathname, user.canTransact]);
  
  const toggleNav = () => {
    document.getElementById("content")?.classList.toggle("active");
    document.getElementById("sidebar")?.classList.toggle("active");
    document.getElementById("small-nav-overlay")?.classList.toggle("active");
  };

  const toggleProfile = (event: any, action: string) => {
    event.stopPropagation();
    const element = document.getElementById("switch-account-menu");
    if (action === "add") {
      element?.classList.add("show");
    } else if (action === "remove") {
      element?.classList.remove("show");
    }
  };

  return (
    <>
      <nav className={classes.nav}>
        <div className={classes.navInner}>
          <button
            type="button"
            id="BigsidebarCollapse"
            className="btn scary"
            onClick={toggleNav}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div
            role="button"
            className="d-flex align-items-center switch-account-container"
            onClick={(event) => toggleProfile(event, "add")}
          >
            <img src={user.imageSrc} alt={user.nameAlf} />
            <span className="switch-account-container__account-info">
              {user.nameAlf} • <span>joint</span>
            </span>
            <span className="chevron-down"></span>

            <div id="switch-account-menu" className="switch-account-menu">
              <div className="df switch-account-menu-header">
                <div className="d-flex align-items-center">
                  <h6 className="mr-2">Accounts</h6>
                </div>
                <button onClick={(event) => toggleProfile(event, "remove")}>
                  <img src="/imgs/close.svg" alt="close" />
                </button>
              </div>
              <ul
                style={{ marginBottom: "1rem" }}
                className="switch-account-menu-accounts"
              ></ul>
            </div>
          </div>
        </div>
      </nav>

      {/* Transaction Restriction Alert */}
      {accountLockDownLevel === 0 && showAlert && (
        <div className="transaction-alert fade-in">
          <div style={{marginRight: '0.5rem'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" className="injected-svg" data-src="/static/media/info.e0b82d7c.svg">
                <path d="M11 22C4.9 22 0 17.1 0 11C0 4.9 4.9 0 11 0C17.1 0 22 4.9 22 11C22 17.1 17.1 22 11 22ZM11 2C6 2 2 6 2 11C2 16 6 20 11 20C16 20 20 16 20 11C20 6 16 2 11 2Z" fill="#d03c6a"></path>
                <path d="M11 12C10.4 12 10 11.6 10 11V7C10 6.4 10.4 6 11 6C11.6 6 12 6.4 12 7V11C12 11.6 11.6 12 11 12Z" fill="#d03c6a"></path>
                <path d="M11 16C10.7 16 10.5 15.9 10.3 15.7C10.1 15.5 10 15.3 10 15C10 14.9 10 14.7 10.1 14.6C10.2 14.5 10.2 14.4 10.3 14.3C10.6 14 11 13.9 11.4 14.1C11.5 14.1 11.5 14.1 11.6 14.2C11.6 14.2 11.7 14.3 11.8 14.3C11.9 14.4 12 14.5 12 14.6C12 14.7 12 14.9 12 15C12 15.1 12 15.3 11.9 15.4C11.8 15.5 11.8 15.6 11.7 15.7C11.5 15.9 11.3 16 11 16Z" fill="#d03c6a"></path>
            </svg>
          </div>
          Your account is currently on Level 2 lockdown.
          Please visit your local branch to complete a routine verification.
        </div>
      )}
    </>
  );
};

export default AppBar;
